import IconButton from "@mui/material/IconButton"

interface CustomIconButtonProps extends React.ComponentPropsWithoutRef<typeof IconButton> {
  children: React.ReactNode;
}
const CustomIconButton: React.FC<CustomIconButtonProps>  = ({children, ...props}) => {
  return (
    <IconButton
      color="primary"
      sx={{
        padding: 6,
        backgroundColor: 'primary.main',
        color: 'white',
        '&:hover': { backgroundColor: 'primary.dark' },
      }}
      {...props}
    >
      {children}
    </IconButton>
  )
}

export default CustomIconButton;